import Vue from 'vue';
import Errors from '../classes/errors';
import { OWNER_RECALL_MESSAGES } from '../consts/owner-recall-messages';
import { isCaptchaEnabled } from '../services/captcha';
import { setCaptchaEuScript } from '../utils/set-captchaeu-script';

Vue.component('owner-recall-search-component', {
    props: {
        siteHandle: String,
        captchaEuPublicKey: String,
    },

    data() {
        return {
            searchQuery: '',
            searchResults: undefined, // undefined if no search has been made, null if search has been made and no results were found, object if results were found
            searchError: false, // true if the lookup itself failed (rate limited, captcha rejected, server error) — distinct from a genuine not-found
            vinError: false,
            awaitingSearch: false,
            errors: new Errors(),
        };
    },

    watch: {
        vinError(value) {
            if (!value) {
                this.errors.clear();
                return;
            }

            this.errors.record({ vin: ['owner-manual-error'] });
        },
    },

    mounted() {
        setCaptchaEuScript();
        document.addEventListener('keydown', this.setSearchQueryOnEnter);
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.setSearchQueryOnEnter);
    },

    methods: {
        getRecallMessage(campaignCode) {
            return OWNER_RECALL_MESSAGES[this.siteHandle][campaignCode];
        },
        setSearchQueryOnEnter(event) {
            if (event.key === 'Enter') {
                this.setSearchQuery();
            }
        },
        throttledSearch() {
            if (!this.awaitingSearch) {
                setTimeout(() => {
                    this.search();
                    this.awaitingSearch = false;
                }, 500);
            }
            this.awaitingSearch = true;
        },
        setSearchQuery() {
            const input = this.$el.querySelector('#vin');
            this.searchQuery = input.value;
            this.search(input.value);
        },
        async search(searchProperty) {
            this.vinError = false;
            this.searchError = false;
            const search = (searchProperty || this.searchQuery).toUpperCase();

            if (search.length === 0) {
                this.searchResults = undefined;
                return;
            }

            if (search.length !== 17 && search.length > 0) {
                this.vinError = true;
                return;
            }

            try {
                const captchaSolution = (await isCaptchaEnabled())
                    ? await KROT.getSolution(this.captchaEuPublicKey)
                    : null;

                const formData = new FormData();
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }

                const response = await axios.post(
                    `/v1/owners/recall/${search}`,
                    formData,
                );
                this.searchResults = response.data;
            } catch (error) {
                this.searchResults = undefined;
                this.searchError = true;
            }
        },
    },
});
